import React, { ReactNode } from 'react'
import cn from 'classnames'
import { Button, IconChevronRightDefault } from '@mc/design-system'
import styles from './styles.module.scss'

interface BreadcrumbBarProps {
  className?: string
  children: React.ReactNode
}

export const BreadcrumbBar = ({ className, children }: BreadcrumbBarProps) => (
  <div
    className={cn(
      'container d-flex flex-nowrap align-items-center',
      className,
      styles.scrollContainer,
    )}
  >
    {children}
  </div>
)

interface BreadcrumbItemProps {
  children: ReactNode
  href?: string
  onClick?: () => void
}

const BreadcrumbItem = ({ children, href, onClick }: BreadcrumbItemProps) =>
  href ? (
    <Button
      className={`${styles.clickableBreadcrumbItem} flex-shrink-0 mc-py-1 mc-px-3 mc-text-small mc-corners--1`}
      size='small'
      kind='secondary'
      render={<a href={href} />}
      onClick={onClick}
    >
      {children}
    </Button>
  ) : (
    <span className='flex-shrink-0 mc-text-small mc-text--bold mc-text-color--tint'>
      {children}
    </span>
  )

const BreadcrumbItemSeparator = () => (
  <IconChevronRightDefault className='flex-shrink-0 mc-mx-1' />
)

BreadcrumbBar.Item = BreadcrumbItem
BreadcrumbBar.Separator = BreadcrumbItemSeparator
